import axios from "axios";
import { BACKEND_URL } from "../constants";

const post = async (path, body) => {
  const { data } = await axios.post(`${BACKEND_URL}${path}`, body, { withCredentials: true });
  return data;
};

const ids = (user, company) => ({ userId: user._id, companyId: company._id });

export const get_history_access = ({ user, company }) => post("/history/access", ids(user, company));

export const list_history = ({ user, company, filters, beforeId, limit = 50 }) =>
  post("/history/list", { ...ids(user, company), filters, beforeId, limit });

export const get_history_record = ({ user, company, recordId }) =>
  post("/history/record", { ...ids(user, company), recordId });

export const get_shift_history = ({ user, company, shiftId }) =>
  post("/history/shift", { ...ids(user, company), shiftId });

export const get_history_people = ({ user, company }) => post("/history/people", ids(user, company));

export const set_history_access = ({ user, company, targetUserId, allowed }) =>
  post("/history/access/set", { ...ids(user, company), targetUserId, allowed });
